module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-h2"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/part1"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" I. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVIL")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICHMOND")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/part1#pt1lev1sec1"
    }
  }, [_vm._v("Dearest Love, Do You Remember?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/part1#pt1lev1sec2"
    }
  }, [_vm._v("General T.J. Jackson Goes to Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/part1#pt1lev1sec3"
    }
  }, [_vm._v("Jewish Soldiers of the South")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/part1#pt1lev1sec4"
    }
  }, [_vm._v("The Faded Doves of Richmond")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/part1#pt1lev1sec5"
    }
  }, [_vm._v("James Ewell Brown Stuart: The General Who Gave His Life to Save Richmond")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/part1#pt1lev1sec6"
    }
  }, [_vm._v("Duty Done: The Legacy of Robert E. Lee")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/part1#pt1lev1sec7"
    }
  }, [_vm._v("The Return of the Confederate Dead from Gettysburg")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" II. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WENTIETH")]), _vm._v("-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CENTURY")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICHMOND")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#pt2lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Richmond Remembers the "), _c('i', [_vm._v("Titanic")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#pt2lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Great Mail Robbery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#pt2lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Death at Dusk: The McCarty-Mordecai Duel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#pt2lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Jasper: The Preacher Who Moved the Sun")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#pt2lev1sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saved by a Meteor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#pt2lev1sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Richmond City Auditorium")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#pt2lev1sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White Ribbons, Temperance and a Richmond Water Fountain")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#pt2lev1sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hollywood Cemetery and the Big Black Dog")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#pt2lev1sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("920 West Franklin Street: A House of Memories")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#pt2lev1sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christopher Columbus: Admiral of the Ocean Sea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#pt2lev1sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cannon Memorial Chapel at the University of Richmond")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" III. W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORLD")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR")]), _vm._v(" II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part3#pt3lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Death in the South Pacific")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part3#pt3lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Richmond Pigeons: Fast-Flying, Feathered Freedom Fighters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part3#pt3lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The USS "), _c('i', [_vm._v("Richmond")]), _vm._v(" (CL-9)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" IV. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RANSPORTATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part4#pt4lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Last Kiss: The Collapse of the Church Hill Tunnel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part4#pt4lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Flight of the Gold Bug: The First Airplane to Fly Over Richmond")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part4#pt4lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Kline Kar Comes to Richmond")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part4#pt4lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Memories of Richmond’s Horses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part4#pt4lev1sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Richmond’s Steam Locomotive No. 2732")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part4#pt4lev1sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When Richmond Was a City of Streetcars")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part4#pt4lev1sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Richmond’s Main Street Station")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part4#pt4lev1sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Richmond’s Broad Street Station")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part4#pt4lev1sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Train of Tomorrow Comes to Richmond")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part4#pt4lev1sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waiting for a Train")])]), _vm._v(" "), _c('p', {
    staticClass: "top-space"
  }), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-624f1122","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0